export const SDK_VERSION = '7.95.0';
